module.exports = __webpack_public_path__ + "img/joel@2x.0946fa11.jpg";